import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import ModalVideo from 'react-modal-video';

import about1 from '../assets/images/about/1.jpg'
import about2 from '../assets/images/about/2.jpg'
import about3 from '../assets/images/about/3.jpg'
import about4 from '../assets/images/about/4.jpg'

export default function AboutTwo() {
    let [isOpen, setOpen] = useState(false);

  return (
    <>
    <div className="position-relative">
        <div className="position-relative mover z-1">
            <div className="row align-items-end">
                <div className="col-7">
                    <img src={about1} className="img-fluid rounded" alt=""/>
                </div>

                <div className="col-5">
                    <img src={about3} className="img-fluid rounded" alt=""/>
                </div>
            </div>

            <div className="row align-items-start mt-4">
                <div className="col-5">
                    <img src={about4} className="img-fluid rounded" alt=""/>
                </div>

                <div className="col-7">
                    <img src={about2} className="img-fluid rounded" alt=""/>
                </div>
            </div>

            <div className="position-absolute top-50 start-50 translate-middle">
                <Link to="#!" onClick={() => setOpen(true)} className="avatar avatar-md-md rounded-pill shadow card d-flex justify-content-center align-items-center lightbox">
                    <i className="mdi mdi-play mdi-24px text-primary"></i>
                </Link>
            </div>
        </div>
        
        <ModalVideo
            channel="youtube"
            youtube={{ mute: 0, autoplay: 0 }}
            isOpen={isOpen}
            videoId="yba7hPeTSjk"
            onClose={() => setOpen(false)} 
        />

        <div className="position-absolute top-50 start-50 translate-middle">
            <div className="bg-primary rounded opacity-75 p-5"><div className="p-5 m-5"></div></div>
        </div>
    </div>
    </>
  )
}
